var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isShow ? _c('portal', {
    attrs: {
      "to": "lm-modal"
    }
  }, [_c('div', {
    staticClass: "selectStoragePopup Popup__depth3"
  }, [_c('div', {
    staticClass: "Popup__background"
  }), _c('div', {
    staticClass: "Popup__container Popup__size-sm"
  }, [_c('div', {
    staticClass: "Popup__top"
  }, [_c('h5', {
    staticClass: "Popup__title"
  }, [_vm._v(" " + _vm._s(_vm.tt(_vm.title)) + " ")]), _c('button', {
    staticClass: "Popup__close-btn",
    on: {
      "click": _vm.close
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/svg/popup-close.svg"),
      "alt": "close"
    }
  })])]), _c('div', {
    staticClass: "Popup__content"
  }, [_c('lm-input-search', {
    attrs: {
      "placeholder": _vm.placeholder
    },
    on: {
      "search": _vm.searchTree
    }
  }), _c('div', [_c('ul', {
    staticClass: "horizational-list"
  }, [_vm.treeData ? _c('tree-view', {
    key: "modal-tree-view",
    ref: "modal-tree-view",
    attrs: {
      "textField": "name",
      "draggable": false,
      "mode": _vm.mode,
      "selectWithChild": _vm.checkChild,
      "keyword": _vm.keyword,
      "treeData": _vm.treeData,
      "modal": "location"
    },
    on: {
      "changeActive": _vm.getActiveId,
      "load": _vm.loadedTree
    }
  }) : _vm._e()], 1)])], 1), _c('div', {
    staticClass: "Popup__bottom"
  }, [_c('button', {
    staticClass: "Btn__management",
    on: {
      "click": _vm.goManagementLocation
    }
  }, [_vm._v(" " + _vm._s(_vm.tt('위치 관리')) + " ")]), _c('div', {
    staticClass: "Popup__complete-btn-group Popup__btn-group"
  }, [_c('button', {
    staticClass: "Btn__close",
    on: {
      "click": _vm.close
    }
  }, [_vm._v(" " + _vm._s(_vm.tt('취소')) + " ")]), _c('button', {
    staticClass: "Btn__complete",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" " + _vm._s(_vm.tt('완료')) + " ")])])])])])]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }